import { FlowStepData } from "../FlowStepData";

export class LogStep extends FlowStepData {
    readonly __type: string = "log_step";

    constructor() {
        super();
        this.name = "Log";
    }
}
